import "./App.scss";
import { useEffect, useState } from "react";
import HomePage from "./Pages/HomePage";
import LoginPage from "./Pages/LoginPage";
import NotFound from "./Pages/NotFoundpage";
import MailVerify from "./Pages/MailVerifyPage";
import RegisterPage from "./Pages/RegisterPage";
import Sidebar from "./Container/Sidebar/Sidebar";
import ForgotPassword from "./Pages/ForgotPassword";
import PublicFormPage from "./UserPages/PublicFormPage";
import { RouterItems } from "./ProtectedRoutes/RouterItems";
import ProtectedRoute from "./ProtectedRoutes/ProtectedRoute";
import { useGlobalContext } from "./ContextApi/GlobalContext";
import { useSessionBootstrap } from "./Hooks/useSessionBootstrap";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage";
import ContactPage from "./Pages/ContactPage";
import TermsPage from "./Pages/TermsPage";
import BugsPage from "./Pages/BugsPage";
import Header from "./Components/Header/Header";
import LoginModal from "./Components/Modal/LoginModal";
import Footer from "./Components/Footer/Footer";
import DevelopmentPage from "./Pages/DevelopmentPage";
import ResourcesPage from "./Pages/ResourcesPage";
import ScrollToTop from "./Container/ScrollToTop/ScrollToTop";
import MobileAppBar from "./Container/MobileAppBar/MobileAppBar";
import MobileBottomNav from "./Container/MobileBottomNav/MobileBottomNav";
import { useSyncPageTitle } from "./Hooks/useSyncPageTitle";

function AppContent() {
  const location = useLocation();
  const { state } = useGlobalContext();
  const { bootstrapSession } = useSessionBootstrap();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const isPublicForm = location.pathname.startsWith("/f/");
  const isFormBuilder =
    location.pathname === "/forms/create" ||
    location.pathname.startsWith("/forms/edit/");

  useSyncPageTitle();

  useEffect(() => {
    if (state?.authToken) {
      bootstrapSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.authToken]);

  return (
    <>
      <ScrollToTop />
      {!isPublicForm && (
        <>
          {state?.authToken ? (
            <>
              {!isFormBuilder && <MobileAppBar />}
              <Sidebar />
              {!isFormBuilder && <MobileBottomNav />}
            </>
          ) : (
            <Header setIsLoginOpen={setIsLoginOpen} />
          )}
        </>
      )}

      {isLoginOpen && (
        <LoginModal
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
        />
      )}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify" element={<MailVerify />} />
        <Route path="/f/:formId" element={<PublicFormPage />} />
        <Route path="/solutions" element={<DevelopmentPage />} />
        <Route path="/resources" element={<ResourcesPage />} />

        <Route element={<ProtectedRoute />}>
          {RouterItems?.map((route, index) => (
            <Route key={index} path={route?.link} element={route?.page} />
          ))}
        </Route>

        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/report-bugs" element={<BugsPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isPublicForm && !state?.authToken && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
